"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[7833],{

/***/ 20195:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {



var _interopRequireDefault = __webpack_require__(71600);

Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports["default"] = void 0;

var _objectWithoutPropertiesLoose2 = _interopRequireDefault(__webpack_require__(15538));

var _deepmerge = _interopRequireDefault(__webpack_require__(39714));

var _theme = _interopRequireDefault(__webpack_require__(51337));

const createPalette = _ref => {
  let {
    palette = {}
  } = _ref,
      theme = (0, _objectWithoutPropertiesLoose2.default)(_ref, ["palette"]);
  const {
    colors,
    baseColors
  } = theme;
  const colorPalette = {
    luContent: {
      base: baseColors.shock.base,
      dark: baseColors.shock.dark,
      text: colors.white
    },
    primary: {
      base: colors.blue,
      dark: colors.darkBlue,
      text: colors.white
    },
    secondary: {
      base: colors.green,
      dark: colors.darkGreen,
      text: colors.white
    },
    error: {
      base: colors.red,
      text: colors.white
    },
    alert: {
      info: {
        base: baseColors.magablu.light,
        text: baseColors.magablu.dark
      },
      success: {
        base: baseColors.lima.light,
        text: baseColors.lima.dark
      },
      warning: {
        base: baseColors.pizza.light,
        text: baseColors.pizza.dark
      },
      danger: {
        base: baseColors.vermillion.light,
        text: baseColors.vermillion.dark
      }
    },
    text: {
      white: colors.base,
      base: colors.darkSilver,
      light: colors.gray,
      lighter: colors.silver,
      lightest: colors.white,
      dark: colors.black,
      primary: colors.blue,
      scratched: colors.darkGray,
      luContentLink: baseColors.shock.base,
      gray: baseColors.gray.base,
      attributeLabel: colors.greyishBrown,
      greyishBlue: colors.greyishBlue,
      error: colors.red,
      davysGray: colors.davysGray
    },
    textContrast: {
      light: colors.base,
      dark: colors.black
    },
    background: {
      white: colors.base,
      base: colors.lightSilver,
      lighter: colors.white,
      darker: colors.lightGray,
      dark: colors.gray,
      whisper: colors.whisper,
      primary: colors.blue,
      secondary: colors.lightGray,
      primaryDark: colors.darkBlue,
      limeGreen: colors.limeGreen,
      deepGreen: colors.deepGreen,
      luContentPrimary: baseColors.shock.base,
      overlay: baseColors.overlay.base,
      opacityBlue: colors.opacityBlue,
      magablu: colors.blue,
      magabluDark: colors.darkBlue,
      magabluLight: baseColors.magablu.light
    },
    border: {
      base: colors.silver,
      dark: colors.gray,
      primary: colors.darkBlue,
      light: colors.lightSilver,
      whisper: colors.whisper
    },
    stars: {
      base: baseColors.gold.base,
      disabled: baseColors.gray.light
    },
    icons: {
      base: colors.blue,
      dislike: baseColors.vermillion.base,
      like: baseColors.lima.base,
      disabled: baseColors.gray.light
    }
  };
  return (0, _deepmerge.default)(colorPalette, palette);
};

const createTheme = (theme = {}) => {
  const mergedTheme = (0, _deepmerge.default)(_theme.default, theme);
  return Object.assign({}, mergedTheme, {
    palette: createPalette(mergedTheme)
  });
};

var _default = createTheme;
exports["default"] = _default;

/***/ }),

/***/ 80403:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {



var _interopRequireDefault = __webpack_require__(71600);

Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports["default"] = void 0;

var _createTheme = _interopRequireDefault(__webpack_require__(20195));

const theme = (0, _createTheme.default)();
var _default = theme;
exports["default"] = _default;

/***/ }),

/***/ 51337:
/***/ (function(__unused_webpack_module, exports) {



Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports["default"] = exports.cursor = exports.radii = exports.textContrast = exports.elevations = exports.boxShadows = exports.colors = exports.opacityBlue = exports.baseColors = exports.zIndices = exports.lineHeights = exports.fontWeights = exports.fontSizes = exports.Helvetica = exports.fontFamily = exports.mediaQueries = exports.breakpoints = void 0;
// breakpoints
const breakpoints = ['48em', '64em', '72em']; // defaults to: 768px (tablet), 1024px (laptop), 1152px (laptop M)

exports.breakpoints = breakpoints;
const mediaQueries = {
  small: `@media screen and (min-width: ${breakpoints[0]})`,
  medium: `@media screen and (min-width: ${breakpoints[1]})`,
  large: `@media screen and (min-width: ${breakpoints[2]})`
};
exports.mediaQueries = mediaQueries;
const [sm, md, lg] = breakpoints;
breakpoints.sm = sm;
breakpoints.md = md;
breakpoints.lg = lg; // font

const fontFamily = 'Roboto, Arial, Helvetica, sans-serif';
exports.fontFamily = fontFamily;
const Helvetica = 'Helvetica, sans-serif';
exports.Helvetica = Helvetica;
const fontSizes = [12, 14, 16, 18, 20, 24, 32, 36, 40, 56, 72];
exports.fontSizes = fontSizes;
const fontWeights = {
  light: 300,
  regular: 400,
  medium: 500,
  bold: 700
}; // https://css3-tutorial.net/text-font/font-weight/

exports.fontWeights = fontWeights;
const lineHeights = {
  thin: 12,
  standard: 14,
  plus: 16,
  tall: 18,
  display: 1.25,
  small: 0.8,
  fontSize: 1,
  input: 1.4,
  big: 1.6
};
exports.lineHeights = lineHeights;
const zIndices = [1, 10, 1040, 1050, 1060]; // spaces

exports.zIndices = zIndices;
const space = [0, 4, 8, 16, 32, 64, 128, 256, 512]; // ref: [https://magazine.atlassian.net/wiki/spaces/DSM/pages/941261008/Cores]

const baseColors = {
  magablu: {
    base: '#0086ff',
    light: '#e5f3ff',
    dark: '#005eb2'
  },
  lima: {
    base: '#00d604',
    light: '#edfaee',
    dark: '#008002'
  },
  pizza: {
    base: '#ff8a00',
    light: '#ffe8cc',
    dark: '#b26100'
  },
  vermillion: {
    base: '#ff253a',
    light: '#ffe5e8',
    dark: '#b20919'
  },
  gold: {
    base: '#fcd000',
    light: '#fcf3ca',
    dark: '#cca800'
  },
  shock: {
    base: '#a400e1',
    light: '#ecdaf2',
    dark: '#6c0094'
  },
  fini: {
    base: '#ff37a8',
    light: '#fddcef',
    dark: '#b22676'
  },
  wildsand: {
    base: '#f4f4f4',
    light: '#fafafa',
    dark: '#e5e5e5'
  },
  gray: {
    base: '#8c8c8c',
    light: '#b9b9b9',
    dark: '#404040'
  },
  white: {
    base: '#ffffff'
  },
  overlay: {
    base: 'rgba(0, 0, 0, 0.63)',
    dark: 'rgba(0, 0, 0, 0.80)',
    light: 'rgba(229, 229, 229, 0.80)'
  }
}; // color palette

exports.baseColors = baseColors;
const base = '#ffffff';
const black = '#010101';
const white = '#fefefe';
const lightGray = '#ededed';
const lightSilver = '#ececec';
const orange = '#eb8636';
const red = '#c00';
const gray = '#9b9b9b';
const greyish = '#aaaaaa';
const greyishBrown = '#515151';
const greyishBlue = '#cce6f4';
const darkGray = '#808080';
const whisper = '#e5e5e5';
const silver = '#bcbcbc';
const darkSilver = '#404040';
const green = '#59c00b';
const darkGreen = '#479908';
const limeGreen = '#47FF97';
const deepGreen = '#11C11B';
const blue = '#0086ff';
const darkBlue = '#005eb2';
const lightBlue = '#aad0e6';
const pink = '#a23f97';
const davysGray = '#595959';
const opacityBlue = 'rgba(0, 134, 255, 0.11);';
exports.opacityBlue = opacityBlue;
const colors = {
  base,
  black,
  white,
  lightGray,
  lightSilver,
  orange,
  red,
  silver,
  darkSilver,
  gray,
  greyish,
  greyishBrown,
  greyishBlue,
  darkGray,
  green,
  darkGreen,
  limeGreen,
  deepGreen,
  blue,
  darkBlue,
  lightBlue,
  whisper,
  pink,
  opacityBlue,
  davysGray
}; // boxShadows

exports.colors = colors;
const boxShadows = [`0 0 2px 0 rgba(0,0,0,.08),0 1px 4px 0 rgba(0,0,0,.16)`, `0 0 2px 0 rgba(0,0,0,.08),0 2px 8px 0 rgba(0,0,0,.16)`, `0 0 2px 0 rgba(0,0,0,.08),0 4px 16px 0 rgba(0,0,0,.16)`, `0 0 2px 0 rgba(0,0,0,.08),0 8px 32px 0 rgba(0,0,0,.16)`, `0px 2px 12px rgba(81, 81, 81, 0.12)`];
exports.boxShadows = boxShadows;
const elevations = [`0 0 0 0 rgba(0,0,0,.2), 0 0 0 0 rgba(0,0,0,.14), 0 0 0 0 rgba(0,0,0,.12)`, `0 2px 1px -1px rgba(0,0,0,.2), 0 1px 1px 0 rgba(0,0,0,.14), 0 1px 3px 0 rgba(0,0,0,.12)`, `0 3px 1px -2px rgba(0,0,0,.2), 0 2px 2px 0 rgba(0,0,0,.14), 0 1px 5px 0 rgba(0,0,0,.12)`, `0 3px 3px -2px rgba(0,0,0,.2), 0 3px 4px 0 rgba(0,0,0,.14), 0 1px 8px 0 rgba(0,0,0,.12)`, `0 3px 3px -2px rgba(0,0,0,.2), 0 3px 4px 0 rgba(0,0,0,.14), 0 1px 8px 0 rgba(0,0,0,.12)`, `0 3px 5px -1px rgba(0,0,0,.2), 0 5px 8px 0 rgba(0,0,0,.14), 0 1px 14px 0 rgba(0,0,0,.12)`, `0 3px 5px -1px rgba(0,0,0,.2), 0 6px 10px 0 rgba(0,0,0,.14), 0 1px 18px 0 rgba(0,0,0,.12)`, `0 4px 5px -2px rgba(0,0,0,.2), 0 7px 10px 1px rgba(0,0,0,.14), 0 2px 16px 1px rgba(0,0,0,.12)`, `0 5px 5px -3px rgba(0,0,0,.2), 0 8px 10px 1px rgba(0,0,0,.14), 0 3px 14px 2px rgba(0,0,0,.12)`, `0 5px 6px -3px rgba(0,0,0,.2), 0 9px 12px 1px rgba(0,0,0,.14), 0 3px 16px 2px rgba(0,0,0,.12)`, `0 6px 6px -3px rgba(0,0,0,.2), 0 10px 14px 1px rgba(0,0,0,.14), 0 4px 18px 3px rgba(0,0,0,.12)`, `0 6px 7px -4px rgba(0,0,0,.2), 0 11px 15px 1px rgba(0,0,0,.14), 0 4px 20px 3px rgba(0,0,0,.12)`, `0 7px 8px -4px rgba(0,0,0,.2), 0 12px 17px 2px rgba(0,0,0,.14), 0 5px 22px 4px rgba(0,0,0,.12)`, `0 7px 8px -4px rgba(0,0,0,.2), 0 13px 19px 2px rgba(0,0,0,.14), 0 5px 24px 4px rgba(0,0,0,.12)`, `0 7px 9px -4px rgba(0,0,0,.2), 0 14px 21px 2px rgba(0,0,0,.14), 0 5px 26px 4px rgba(0,0,0,.12)`, `0 8px 9px -5px rgba(0,0,0,.2), 0 15px 22px 2px rgba(0,0,0,.14), 0 6px 28px 5px rgba(0,0,0,.12)`, `0 8px 10px -5px rgba(0,0,0,.2), 0 16px 24px 2px rgba(0,0,0,.14), 0 6px 30px 5px rgba(0,0,0,.12)`, `0 8px 11px -5px rgba(0,0,0,.2), 0 17px 26px 2px rgba(0,0,0,.14), 0 6px 32px 5px rgba(0,0,0,.12)`, `0 9px 11px -5px rgba(0,0,0,.2), 0 18px 28px 2px rgba(0,0,0,.14), 0 7px 34px 6px rgba(0,0,0,.12)`, `0 9px 12px -6px rgba(0,0,0,.2), 0 19px 29px 2px rgba(0,0,0,.14), 0 7px 36px 6px rgba(0,0,0,.12)`, `0 10px 13px -6px rgba(0,0,0,.2), 0 20px 31px 3px rgba(0,0,0,.14), 0 8px 38px 7px rgba(0,0,0,.12)`, `0 10px 13px -6px rgba(0,0,0,.2), 0 21px 33px 3px rgba(0,0,0,.14), 0 8px 40px 7px rgba(0,0,0,.12)`, `0 10px 14px -6px rgba(0,0,0,.2), 0 22px 35px 3px rgba(0,0,0,.14), 0 8px 42px 7px rgba(0,0,0,.12)`, `0 11px 14px -7px rgba(0,0,0,.2), 0 23px 36px 3px rgba(0,0,0,.14), 0 9px 44px 8px rgba(0,0,0,.12)`, `0 11px 15px -7px rgba(0,0,0,.2), 0 24px 38px 3px rgba(0,0,0,.14), 0 9px 46px 8px rgba(0,0,0,.12)`];
exports.elevations = elevations;
const borders = [`1px solid ${colors.lightGray}`, `2px solid ${colors.silver}`, `3px solid ${colors.silver}`, `4px solid ${colors.lightGray}`];
const textContrast = {
  light: colors.base,
  dark: colors.black
}; // border-radius

exports.textContrast = textContrast;
const radii = {
  small: '2px',
  medium: '4px',
  default: '6px',
  plus: '12px',
  big: '20px',
  large: '40px',
  circle: '50%'
};
exports.radii = radii;
const cursor = {
  pointer: 'pointer',
  default: 'default',
  'not-allowed': 'not-allowed'
};
exports.cursor = cursor;
const theme = {
  baseColors,
  boxShadows,
  borders,
  breakpoints,
  colors,
  cursor,
  elevations,
  fontFamily,
  fontSizes,
  fontWeights,
  Helvetica,
  lineHeights,
  mediaQueries,
  radii,
  space,
  textContrast,
  zIndices,
  zIndex: zIndices,
  shadows: boxShadows
};
var _default = theme;
exports["default"] = _default;

/***/ }),

/***/ 77833:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

var __webpack_unused_export__;


var _interopRequireDefault = __webpack_require__(71600);

__webpack_unused_export__ = ({
  value: true
});
Object.defineProperty(exports, "R", ({
  enumerable: true,
  get: function () {
    return _themeGet.themeGet;
  }
}));
__webpack_unused_export__ = __webpack_unused_export__ = __webpack_unused_export__ = __webpack_unused_export__ = __webpack_unused_export__ = __webpack_unused_export__ = __webpack_unused_export__ = exports.aK = __webpack_unused_export__ = __webpack_unused_export__ = exports.dF = __webpack_unused_export__ = exports.ow = void 0;

var _tinycolor = _interopRequireDefault(__webpack_require__(80184));

var _themeGet = __webpack_require__(78188);

var _theme = _interopRequireDefault(__webpack_require__(80403));

/**
 * Gets theme color from palette, using props.color as the palette color
 * @param {*} path - could be shade (base) or pathTo (border.base)
 * @example getPaletteColor('base')(props) => will return theme.palette[props.color].base
 * @example getPaletteColor('border.base')(props) => will return theme.palette.border.base
 */
const getPaletteColor = path => props => {
  let {
    color = 'primary'
  } = props;
  let shade = path; // default one word

  const pathSplitted = path.split('.');

  if (pathSplitted.length > 1) {
    [color, shade] = pathSplitted;
  }

  return (0, _themeGet.themeGet)(`palette.${color}.${shade}`)(props);
};
/**
 * Gets theme color from palette.text
 * @param {*} shade - palette > color > shade
 * @example getTextColor('light')(props) => will return theme.palette.text.light
 */


exports.ow = getPaletteColor;

const getTextColor = shade => props => {
  return getPaletteColor(`text.${shade}`)(props);
};

__webpack_unused_export__ = getTextColor;

const getBackgroundColor = shade => props => {
  return getPaletteColor(`background.${shade}`)(props);
};

exports.dF = getBackgroundColor;

const getBorderColor = shade => props => {
  return getPaletteColor(`border.${shade}`)(props);
};

__webpack_unused_export__ = getBorderColor;

const getAlertColor = path => props => {
  return (0, _themeGet.themeGet)(`palette.alert.${path}`)(props);
};

__webpack_unused_export__ = getAlertColor;

const getMediaQuery = size => props => {
  const queries = (0, _themeGet.themeGet)('mediaQueries')(props) || {};
  return queries[size];
};

exports.aK = getMediaQuery;

const getFontSize = (size, fallbackSize = 1) => props => (0, _themeGet.themeGet)(`fontSizes.${size}`)(props) || (0, _themeGet.themeGet)(`fontSizes.${fallbackSize}`)(props);

__webpack_unused_export__ = getFontSize;

const getTextContrast = (shade, scale) => props => {
  if (shade) {
    const light = (0, _tinycolor.default)(scale == null ? void 0 : scale.light).isValid() ? scale == null ? void 0 : scale.light : getTextColor(scale == null ? void 0 : scale.light)(props);
    const dark = (0, _tinycolor.default)(scale == null ? void 0 : scale.dark).isValid() ? scale == null ? void 0 : scale.dark : getTextColor(scale == null ? void 0 : scale.dark)(props);
    if (shade.toString().includes('transparent')) return dark || getTextColor('dark')(props);
    const background = getBackgroundColor(shade)(props) || getPaletteColor(shade)(props) || shade;
    const color = (0, _tinycolor.default)(background);

    if (color.isValid() && dark && light) {
      return color.isLight() ? dark : light;
    }
  }

  return getTextColor('dark')(props);
};

__webpack_unused_export__ = getTextContrast;
const getColorHelpers = _tinycolor.default;
__webpack_unused_export__ = getColorHelpers;

/** @returns {String[]} Theme colors's names */
const getThemeColors = () => Object.keys(_theme.default.colors);
/** @returns {String[]} Theme palette's color names */


__webpack_unused_export__ = getThemeColors;

const getThemeColorsFromPalette = () => Object.entries(_theme.default.palette).reduce((acc, [parent, child]) => [...acc, ...Object.keys(child).map(color => `${parent}.${color}`)], []);

__webpack_unused_export__ = getThemeColorsFromPalette;

const getBoxShadows = shadowIndex => props => (0, _themeGet.themeGet)(`boxShadows.${shadowIndex}`)(props);

__webpack_unused_export__ = getBoxShadows;

const darken = (color, amount) => (0, _tinycolor.default)(color).darken(amount).toString();

__webpack_unused_export__ = darken;

/***/ })

}]);